import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ArrowIcon } from 'assets/images/icon/arrow-down.svg';

import Collapse from '@material-ui/core/Collapse';
import PositionPropertyBox from './PropertyBox/PositionPropertyBox';
import ScalePropertyBox from './PropertyBox/ScalePropertyBox';
import RotationPropertyBox from './PropertyBox/RotationPropertyBox';
import CurvePropertyBox from './PropertyBox/CurvePropertyBox';
import { MarkerField } from 'constants/markerFields';
import { MarkerType } from 'core/three/object/type';

const TransformSetting = ({ type, fields }: { type: MarkerType; fields: MarkerField }) => {
    const { t } = useTranslation();
    const [open, setOpen] = React.useState(false);

    const onCloseEvent = () => {
        setOpen((prev) => !prev);
    };

    return (
        <>
            <div className="property-slide-bar" onClick={onCloseEvent}>
                {t('propertyMenu.transformSetting')}
                <button>
                    <ArrowIcon className={open ? 'fa-icon-open' : 'fa-icon-close'} />
                </button>
            </div>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <div className="property-wrapper">
                    <PositionPropertyBox />
                    <ScalePropertyBox />
                    <RotationPropertyBox />
                    {fields.curve && <CurvePropertyBox />}
                </div>
            </Collapse>
        </>
    );
};

export default TransformSetting;
